import type ApolloClient from 'apollo-client'
import gql from 'graphql-tag'
import * as Sentry from '@sentry/react'

export async function cachedQuotesDelete(ids: string[], client: ApolloClient<object>) {
  // Updated cached quotes to be deleted
  const fragment = gql`
    fragment Quote on Quote {
      _id
      _deleted
      trashed
      deleteDate
    }
  `

  ids.forEach((id) => {
    const frag = client.cache.readFragment({
      fragment,
      id: `Quote:${id}`
    }) as any
    // Set deleteDate to 60 days in the future to match backend behavior
    // Note: _deleted should only be true for permanently deleted quotes, not trashed ones
    const deleteDate = new Date().setDate(new Date().getDate() + 60)
    const newData = {
      ...frag,
      trashed: true,
      deleteDate
    }

    try {
      if (frag) {
        client.cache.writeFragment({ fragment, id: `Quote:${id}`, data: newData })
      } else {
        console.log('cache write error', { fragment, newData, id })
        // Sentry.captureException(new Error('No cached frag found on delete'), { tags: { quoteId: id } })
      }
    } catch (e) {
      console.log('cache write error', { frag, newData })
      console.log(e)
      Sentry.captureException(e, { tags: { quoteId: id } })
    }
  })
}
